<template lang="pug">
  .profile-page__main
    .profile-page__header
      .profile-page__title
        h1.title Редактирование лагеря
    .profile-page__body
      .manager-camp
        .manager-camp__tabs
          tab-nav(
          :tab-nav-data="tabs"
          )
        .manager-camp__main
          router-view(
          :camp-data="campData"
          @on-save-camp="onSaveCamp"
          @on-get-camp-data="onGetCampData"
          @on-delete-camp-house="onDeleteCampHouse"
          )

</template>

<script>
import {mapActions} from "vuex";
import TabNav from "../../../../../components/tabNav/TabNav";

export default {
  name: "ManagerCampEditor",
  components: {TabNav},
  data() {
    return {
      tabs: [
        {
          text: "О лагере",
          path: "about"
        },
        {
          text: "Размещение",
          path: "placement"
        },
        {
          text: "Документы",
          path: "docs"
        },
        {
          text: "Памятка родителям",
          path: "things"
        },
        {
          text: "Контакты",
          path: "contacts"
        }
      ],
      campData: null
    };
  },
  computed: {
    campId() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapActions(["getCamp", "updateCamp", "deleteCampHouse"]),
    onSaveCamp(data) {
      this.updateCamp({
        id: this.campId,
        data: data
      }).then(res => {
        if (res.status === 200) {
          this.campData = res.data;
          this.$root.$emit("onShowNotificationModal", {
            text: "Лагерь обновлен"
          });
        } else {
          this.$root.$emit("onShowErrorModal", {
            text: `${res.status} ошибка`
          });
        }
      });
    },
    onGetCampData() {
      this.getCamp(this.campId).then(res => {
        this.campData = res;
        this.$root.$emit("on-hide-preloader");
      });
    },
    onDeleteCampHouse(house) {
      this.deleteCampHouse(house.id).then(res => {
        if (res.status === 204) {
          this.onGetCampData();
        } else if (res.status === 400) {
          let errorText;
          if (res.data[0].code === 19) {
            errorText = "В данный корпус подана заявка. Удаление корпуса невозможно. Отклоните заявку в квоту, связанную с этим корпусом или отредактируйте квоту - укажите другой корпус. После повторите попытку удаления корпуса.";
          } else {
            errorText = res.data[0].message;
          }
          this.$root.$emit("onShowErrorModal", {
            text: errorText
          });
        }
      });
    }
  },
  created() {
    this.$root.$emit("on-show-preloader");
  },
  mounted() {
    this.onGetCampData();
  }
};
</script>
